import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { FeeTransferType, TransferFeesPayload } from '../components/TransferFees/types'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'

export const buildApiUrl = (transferTypeDirection: FeeTransferType, accountNumber: string): string => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${SENTINEL_API}/transfer_fees/${accountNumber}/${transferTypeDirection}`
}

export default function useGetTransferFees(transferType: FeeTransferType, accountNumber: string) {
  const getTransferFeesUrl = buildApiUrl(transferType, accountNumber)

  const getTransferFees = async () => {
    const { data } = await axios.get(getTransferFeesUrl, {
      withCredentials: true
    })
    return data as TransferFeesPayload[]
  }

  return useQuery<TransferFeesPayload[], AxiosError>(['transferFees', accountNumber, transferType], getTransferFees, {
    // The query will not execute until the accountNumber exists
    enabled: !!accountNumber
  })
}
